import { parseDomainUrl } from './parse-domain-url.js'

export function parseDomainList(payload: unknown): string[] | undefined {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) return undefined
  const domains = (payload as Record<string, unknown>).domains
  if (!Array.isArray(domains)) return undefined

  const parsed = domains.map(parseDomainUrl)
  return parsed.every((domain): domain is string => Boolean(domain)) ? parsed : undefined
}
